import type { Custodian } from 'models/custodian';

export function findDefaultCustodianId(custodians: Custodian[], clientId: string) {
  if (custodians?.length === 1) {
    return custodians[0].id;
  }
  return custodians?.find(c => c.id === clientId)?.id;
}
